import * as types from 'store/mutation-types'

export default store => {
  // sync with stock removing mutation
  store.subscribe(({ type, payload }) => {
    if (store.state.views.type === 1) {
      return
    }
    if (type !== types.DELETE_TRADE_STOCK) {
      return
    }
    const listIndex = store.state.views.list.findIndex(stock => {
      return stock && stock.symbol === payload.symbol
    })

    store.dispatch('setViewSlot', [listIndex, null])
  })
}
